import styled, { css } from 'styled-components'

import MenuItem from '../menuItem'
import type { MenuItemProps } from '../menuItem/types'

type MenuExternalLinksProps = {
  externalMenuItems: {
    title: string
    links: Array<MenuItemProps>
  }
  isOpenMenu: boolean
}

const Wrapper = styled.div<{ isOpenMenu: boolean }>`
  transform: translateX(-20rem);
  transition: transform var(--timing) var(--easing);

  ${({ isOpenMenu }) =>
    isOpenMenu &&
    css`
      transform: none;
    `}
`

const MenuExternalLinks = ({ externalMenuItems, isOpenMenu = false }: MenuExternalLinksProps) => {
  return (
    <Wrapper
      className='_mt-4 _d-flex _flex-column _overflow-hidden _border-top _pt-4 _pb-4 external-links'
      isOpenMenu={isOpenMenu}>
      <h3 className='_mb-4 _ml-4 _mt-4 _text-gray-500 _font-weight _text-1 _text-uppercase'>
        {externalMenuItems.title}
      </h3>

      {externalMenuItems.links?.map(({ label, iconSecondary, onClick }, index) => (
        <MenuItem key={index} label={label} iconSecondary={iconSecondary} onClick={onClick} />
      ))}
    </Wrapper>
  )
}

export default MenuExternalLinks
